import { hasMarkdownPage, markdownPath } from './markdownHttp'

type PageMatch = {
  routeId: string
  pathname: string
  status: string
  loaderData?: unknown
}

export function isMissingPage(page: PageMatch | undefined) {
  return (
    page?.status === 'notFound' ||
    page?.routeId === '/$' ||
    Boolean(page?.pathname.startsWith('/blog') && page.loaderData === undefined)
  )
}

export function pageMarkdownHref(page: PageMatch | undefined) {
  const data = page?.loaderData as
    { markdownSearch?: Record<string, unknown> } | undefined
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(data?.markdownSearch ?? {})) {
    if (
      value !== undefined &&
      value !== '' &&
      (key !== 'page' || Number(value) > 1)
    )
      query.set(key, String(value))
  }
  return page?.status === 'success' &&
    !isMissingPage(page) &&
    hasMarkdownPage(page.pathname)
    ? markdownPath(`${page.pathname}${query.size ? `?${query}` : ''}`)
    : undefined
}
